import { SxProp, View } from 'dripsy';
import React from 'react';

export interface StepProps<T> {
  sx?: SxProp;
  step: number;
  sxStep?: SxProp;
}

export const Step = <T extends unknown>({ sx, step = 0, sxStep }: StepProps<T>) => {
  return (
    <View
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        width: 40,
        height: 40,
        backgroundColor: '$backgroundInputActive',
        borderRadius: 50,
        ...sx
      }}>
      <View sx={{ fontWeight: 700, fontSize: 20, lineHeight: 28, color: '#FFFFFF', ...sxStep }}>{step}</View>
    </View>
  );
};
